import script from "./countDown.vue?vue&type=script&setup=true&lang=js"
export * from "./countDown.vue?vue&type=script&setup=true&lang=js"

import "./countDown.vue?vue&type=style&index=0&id=2ddb954b&lang=scss&scoped=true"

import exportComponent from "/Users/zhuweiyun/Desktop/zwy/vue3-天空之城/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ddb954b"]])

export default __exports__